(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fake-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const roots = document.querySelectorAll('[data-countdown-root]');

    roots.forEach(function (root) {
      const durationMinutes = parseInt(root.getAttribute('data-countdown-duration') || '180', 10);
      const timerEl = root.querySelector('[data-countdown-timer]');
      if (!timerEl) return;

      const countdownMs = durationMinutes * 60 * 1000;
      const startTime = Date.now();

      function formatUnit(value, unit) {
        return value > 0 ? value + unit : '';
      }

      function update() {
        const now = Date.now();
        const diff = countdownMs - (now - startTime);

        let text;

        if (diff <= 0) {
          text = '0m 00s';
        } else {
          const totalSeconds = Math.floor(diff / 1000);
          const hours = Math.floor(totalSeconds / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;

          const parts = [];
          if (hours) parts.push(formatUnit(hours, 'h'));
          if (minutes || hours) parts.push(formatUnit(minutes, 'm'));
          parts.push(formatUnit(seconds.toString().padStart(2, '0'), 's'));

          text = parts.join(' ');
        }

        timerEl.textContent = text;
      }

      update();
      setInterval(update, 1000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const bars = document.querySelectorAll(
      'announcement-bar-component[data-countdown-enabled="true"]'
    );

    bars.forEach(function (bar) {
      const targetStr = bar.getAttribute('data-countdown-target');
      if (!targetStr) return;

      const parsed = targetStr.replace(' ', 'T');
      const target = new Date(parsed);
      if (isNaN(target.getTime())) return;

      const label = bar.getAttribute('data-countdown-label') || '';
      const slides = bar.querySelectorAll('.announcement-bar__slide');
      if (!slides.length) return;

      const timerEls = [];

      slides.forEach(function (slide) {
        let timer = slide.querySelector('.announcement-bar__timer');
        if (!timer) {
          timer = document.createElement('span');
          timer.className = 'announcement-bar__timer';
          slide.appendChild(timer);
        }
        timerEls.push(timer);
      });

      function formatUnit(value, unit) {
        return value > 0 ? value + unit : '';
      }

      function update() {
        const now = new Date().getTime();
        const diff = target.getTime() - now;

        let text;
        if (diff <= 0) {
          text = 'Ended';
        } else {
          const totalSeconds = Math.floor(diff / 1000);
          const days = Math.floor(totalSeconds / 86400);
          const hours = Math.floor((totalSeconds % 86400) / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;

          const parts = [];
          if (days) parts.push(formatUnit(days, 'd'));
          if (hours || days) parts.push(formatUnit(hours, 'h'));
          if (minutes || hours || days) parts.push(formatUnit(minutes, 'm'));
          parts.push(formatUnit(seconds, 's'));

          const countdownText = parts.filter(Boolean).join(' ');
          text = label ? label + ' ' + countdownText : countdownText;
        }

        timerEls.forEach(function (el) {
          el.textContent = text;
        });
      }

      update();
      setInterval(update, 1000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
